import { useState } from 'react'
import { Link } from 'react-router-dom'
import Section from '@/components/Section'
import { usePageTitle } from '@/components/usePageTitle'
import productsData from '@/data/products.json'

const { categories, products } = productsData

export default function Store() {
  usePageTitle('Store', 'ColorMark posters, mugs, and stickers.')
  const [cat, setCat] = useState('All')
  const shown = cat === 'All' ? products : products.filter((p) => p.category === cat)

  return (
    <>
      <Section className="pt-40 md:pt-52">
        <div className="mx-auto max-w-[1800px] text-center">
          <h2>Store</h2>
          <nav className="mt-10 flex flex-wrap justify-center font-body text-[1.1rem]" aria-label="Product categories">
            {categories.map((c, i) => (
              <span key={c} className="flex items-center">
                {i > 0 && <span className="mx-5 text-neutral-300" aria-hidden="true">|</span>}
                <button
                  type="button"
                  onClick={() => setCat(c)}
                  aria-pressed={cat === c}
                  className={cat === c ? 'font-semibold' : 'hover:underline'}
                >
                  {c}
                </button>
              </span>
            ))}
          </nav>

          <p className="mx-auto mt-8 max-w-2xl text-neutral-600">
            Our store is being rebuilt. Merchandise will be available to order again soon. Meanwhile every registered
            color has print-ready artwork on its page: open a color in the <Link to="/registry">registry</Link> and
            choose Merchandise, or see <Link to="/color/dodgerblue/merch">an example</Link>.
          </p>

          {shown.length === 0 ? (
            <p className="mt-20 italic">No {cat.toLowerCase()} yet. Check back soon.</p>
          ) : (
            <ul className="mt-16 grid grid-cols-2 gap-x-6 gap-y-14 md:grid-cols-4 md:gap-x-10">
              {shown.map((p) => (
                <li key={p.slug} className="flex flex-col items-center">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full max-w-[420px]" />
                  <h4 className="mt-6 font-medium">{p.title}</h4>
                  <p className="mt-2 font-body text-[1.05rem]">from ${p.price}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Section>

      <Section className="pt-0 text-center">
        <h2>
          <Link to="/contact">Looking for custom merchandise?</Link>
        </h2>
        <h2 className="mt-12">
          <Link to="/register">Want to register your favorite color?</Link>
        </h2>
      </Section>
    </>
  )
}
